import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { fleetVehicleInformationSchema } from '../schemas/fleet-device-settings.schema';

/**
 * Gets the Device Information for a given set of Device IDs
 * @param deviceIds The Device IDs whose Information is being requested
 * @returns Data object indicating Sync Availability Status
 */
export function getCompanyDevicesInformation(
  this: unknown,
  deviceIds: (null | string)[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyDevicesInformationUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify({ deviceIds }),
      })
    )
  ).pipe(
    selectData(
      z.object({
        data: z.array(fleetVehicleInformationSchema),
        error: z
          .object({
            message: z.string(),
            errorCode: z.number(),
            detail: z.string(),
          })
          .optional(),
      })
    )
  );
}
